/**
 * `pageClasses` — the shared root-element class string for every
 * article-detail surface (populated `<article>`, not-found `<section>`,
 * skeleton `<div role="status">`).
 *
 * Lives in its own tiny module rather than inside
 * `articleDetailSurface.tsx` so `detailSurfaceShell.tsx` can import it
 * without pulling in the surrounding `DetailSurface*` components (which
 * would create a circular import: shell → surface → shell).
 *
 * `pt-back-header` reserves space for the fixed back-header bar that
 * sits at `top-top-bar`. The full padding-stack rationale (the
 * 9.5rem-stack arithmetic — TopBar offset + content rhythm gap +
 * back-header reservation) lives in ONE place: the file-header of
 * `detailSurfaceBackHeader.tsx`. See that module for the math.
 */
export const pageClasses: string = 'flex flex-col gap-4 pt-back-header';
